import React from "react";
import { FaHandPointRight } from "react-icons/fa";
import { DetailsData } from "./DataAbout/DetailsData";

export const Details = () => {
  return (
    <>
      <h3 className="know-h3-about">Knowladge I've<FaHandPointRight /></h3>
      <div className="div-grid-center">
        <section className="about-details-grid">
          {DetailsData.map((Data) => {
            const { id, icon, heading, feel, lang, tools, toolsdetails, dataAos } = Data;
            return (
              <article key={id} className="details-inside-article-box" data-aos={dataAos}>
                <h1>{icon}</h1>
                <h2>{heading}</h2>
                <h4>{feel}:</h4>
                <p className="p1">{lang}</p>
                <h4>{tools}Tools:</h4>
                {toolsdetails.map((tool, index) => {
                  return (
                    <p key={index} className="p2">
                      {tool}
                    </p>
                  );
                })}
              </article>
            );
          })}
        </section>
      </div>
    </>
  );
};
